import api from "@/api/axiosApi";
import handleHttpError from "@/util/HttpErrorHandler";
const API_URL = `/somme`;

export const getSommeContentById = async (id) => {
  const url = `${API_URL}/${id}`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération du contenu de la somme :', error);
    handleHttpError(error, "Impossible de récupérer le contenu de la somme.");
    throw error;
  }
};
